import React, { useCallback } from 'react'

import Modal from 'LuxKit/Modal/Modal'
import BodyText from 'LuxKit/Typography/BodyText'
import useModalElementContext from 'hooks/Modal/useModalElementContext'

export type BusinessTravellerSearchApprovalModalResult = 'stayOnPage' | 'proceedSearch'

/**
 * Confirmation shown when a business traveller starts a new search while inside an approval flow
 * (flight or car hire). Performing a new search exits the approval flow.
 */
function BusinessTravellerSearchApprovalModal() {
  const modalElement = useModalElementContext<BusinessTravellerSearchApprovalModalResult>()

  const onCancel = useCallback(() => {
    modalElement.resolve('stayOnPage')
  }, [modalElement])

  const onProceed = useCallback(() => {
    modalElement.resolve('proceedSearch')
  }, [modalElement])

  return (<Modal
    dismissible={false}
    title="Leaving approval flow"
    primaryActionText="Continue"
    onPrimaryActionClick={onProceed}
    secondaryActionText="Stay on page"
    onSecondaryActionClick={onCancel}
  >
    <BodyText variant="large">Performing a new search will exit the approval flow and you may need to request approval for a new selection. You can return by clicking the link in your approval email.</BodyText>
  </Modal>)
}

export default BusinessTravellerSearchApprovalModal
